<template>
    <div class="Information">
        <div class="row">
            <div class="col">
                <ActionButton class="DeleteButton"
                              :requires-confirmation="true"
                              confirmation-string="WARNING: You are about to delete this child's entire case file, and enrollment in this program.  This is the equivilant of shredding an entire file.  This will not affect the Client Record, or any other enrollment records."
                              endpoint="Foster/FosterClients/DeleteClientSubProgramMembership"
                              :payload="{ProgramMembershipID: ChildRecordData.ClientProgramMembership.Id}"
                              :perform-global-update="true"
                              button-variant="danger"
                              button-string="DELETE CHILD PROGRAM ENROLLMENT RECORD"
                              button-size="md"
                              v-on:success="OnClientSubProgramMembershipDeleted"
                              style="white-space: normal;" />
            </div>
            <div class="col" v-if="CheckPermission('Administrator')">
                <ReportDownloader report-label="Copy Client Docs and Service Log"
                                  endpoint="Core/Clients/ClientMigration/CopyClientMembershipToExistingMembership"
                                  :parameter-schema="Params.ParamsClientMemToFrom"
                                  method="POST"
                                  report-description="Copies a client's documents and service log entries into an existing client's record.  Used for inter-region client transfers." />
            </div>
        </div>
        <!--<div class="row">
            <div class="col padding-top-md pointer" v-on:click="ToggleEditMode()">
                <font-awesome-icon :icon="['fa', 'edit']" />
                <span v-if="EditMode"> Edit Mode: ON</span>
                <span v-else> Edit Mode: OFF</span>
            </div>
        </div>-->
    </div>
</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);
    //import components
    import ActionButton from '../../../Core/ItemEditors/ActionButton.vue';

    import ReportDownloader from '../../../Core/UI/ReportDownloader.vue';

    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false,
                Params: {
                    ParamsClientMemToFrom: [
                        {
                            Label: "From Chart:",
                            Name: "FromClientSubProgramMembershipID",
                            Type: "HiddenConstant",
                            Value: "",
                            DisplayValue: ""
                        },
                        {
                            Label: "To Chart:",
                            Name: "ToClientSubProgramMembershipID",
                            Type: "String",
                            Required: true
                        }
                    ],
                }
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            },
            OnClientSubProgramMembershipDeleted() {
                this.$parent.$parent.CloseRecord("Clients.ClientProfiles.Remove","ChildList",this.ChildRecordData.ClientProgramMembership.Id);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            ActionButton,
            ReportDownloader
        },
        mounted() {
            //SET PARAMS
            //ParamsClientMemToFrom
            this.Params.ParamsClientMemToFrom[0].Value = this.ChildRecordData.Id;
            this.Params.ParamsClientMemToFrom[0].DisplayValue = this.ChildRecordData.Client.Person.FullName;
        },
        computed: {
            
        }
    }
</script>

<style scoped>
    .DeleteButton {
    display: inline-block;
    font-size:4px;
    }
</style>